import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';
import { TranslateService } from '@ngx-translate/core';
import { Toast } from '@capacitor/toast';
import {
  NavigationOption,
  NavigationService,
} from '../../navigation/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class NavigateWoActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'navigate-wo';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private translate: TranslateService,
    private appParameterService: AppParameterService,
    private navigationService: NavigationService
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    let emplat = this.appParameterService.appParameters$.getValue().emplat;

    let emplon = this.appParameterService.appParameters$.getValue().emplon;

    const target: NavigationOption = {};
    target.name = this.translate.instant('PLACE.PLACETYPE.HOME.TITLE');
    if (emplat && emplon) {
      target.coords = {
        latitude: emplat,
        longitude: emplon,
      };
    } else {
      let message = await this.translate
        .get('COMMON.NAVIGATION.NO-LOCATION')
        .toPromise();
      Toast.show({
        text: message,
      });
    }
    this.navigationService.navigateTo(target);
  }

  // Private Functions
}
